import { render, staticRenderFns } from "./EventsAndContactPanel.vue?vue&type=template&id=1564cab2&"
import script from "./EventsAndContactPanel.vue?vue&type=script&lang=js&"
export * from "./EventsAndContactPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/foxik0169/Projects/rattlecinake.com/themes/ultimatefilms/assets/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('1564cab2', component.options)
    } else {
      api.reload('1564cab2', component.options)
    }
    module.hot.accept("./EventsAndContactPanel.vue?vue&type=template&id=1564cab2&", function () {
      api.rerender('1564cab2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/panels/EventsAndContactPanel.vue"
export default component.exports